import React from "react";
import { Div } from "components/Base";

export const Content = ({ children }) => (
  <Div display="column.flex-start.flex-start">{children}</Div>
);

export default Content;
